import { net } from "./pb";
import IMUtils from "./imUtils";

//允许或拒绝好友申请
export const msg_handle_friend_apply = (tauid: number, handletype: number) => {
  const msg = new net.msg_handle_friend_apply();
  msg.otheruid = tauid;
  msg.handletype = handletype;
  let buffer = net.msg_handle_friend_apply.encode(msg).finish();
  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_HANDLE_FRIEND_APPLY, buffer);
}

//修改个性签名
export const mgs_set_sign = (sign: string) => {
  const msg = new net.msg_set_sign();
  msg.sign = IMUtils.encode(sign);;
  let buffer = net.msg_set_sign.encode(msg).finish();
  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_SET_SIGN, buffer);
}

//获取在线状态
export const msg_get_online_state = (uid: number) => {
  const msg = new net.msg_get_online_state();
  msg.uid = uid;
  let buffer = net.msg_get_online_state.encode(msg).finish();
  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_GET_ONLINE_STATE, buffer);
}

//获取好友列表
export const msg_friend_list = () => {
  let msg = new net.msg_friend_list();
  let buffer = net.msg_friend_list.encode(msg).finish();
  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_FRIEND_LIST, buffer);
};
//获取好友申请列表
export const msg_friend_apply_list = () => {
  let msg = new net.msg_friend_apply_list();
  let buffer = net.msg_friend_apply_list.encode(msg).finish();
  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_FRIEND_APPLY_LIST, buffer);
};
//拉取离线消息
export const msg_get_offline_data = () => {
  let msg = new net.msg_get_offline_data();
  let buffer = net.msg_get_offline_data.encode(msg).finish();
  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_GET_OFFLINE_DATA, buffer);
};
//确认读取到了消息，注意，是用户已读
export const msg_confirm_hasread_msg = (chatkey: number, chatmsgno_list) => {
  let msg = new net.msg_confirm_hasread_msg();
  msg.chatkey = chatkey;
  msg.chatmsgno_list = chatmsgno_list;
  let buffer = net.msg_confirm_hasread_msg.encode(msg).finish();
  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_CONFIRM_HASREAD_MSG, buffer);
};
// 获取未读列表
export const msg_get_hasread_list = (chatkey: number, chatmsgno_list) => {
  let msg = new net.msg_get_hasread_list();
  msg.chatkey = chatkey;
  msg.chatmsgno_list = chatmsgno_list;
  let buffer = net.msg_get_hasread_list.encode(msg).finish();
  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_GET_HASREAD_LIST, buffer);
};
//确认拉取到了消息，是确认拉取到了后段的消息
export const msg_confirm_read_msg = (chatkey: number, chatmsgno: number) => {
  let msg = new net.msg_confirm_read_msg();
  msg.chatkey = chatkey;
  msg.chatmsgno = chatmsgno;
  let buffer = net.msg_confirm_read_msg.encode(msg).finish();
  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_CONFIRM_READ_MSG, buffer);
};
//拉取新的消息
export const msg_get_msg_list = (chatkey: number, chatmsgno: number) => {
  const msg = new net.msg_get_msg_list();
  msg.chatkey = chatkey;
  msg.chatmsgno = chatmsgno;
  let buffer = net.msg_get_msg_list.encode(msg).finish();
  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_GET_MSG_LIST, buffer);
};
//发送个人私聊
export const msg_send_private_msg = (tauid, content,type=1, clientkey = '', authcode = '', nopush = 0) => {
  const msg = new net.msg_send_private_msg();
  msg.msg_type = type;

  msg.recvuid = tauid
  msg.content = IMUtils.encode(content);
  msg.clientkey = IMUtils.encode(clientkey);
  msg.authcode = IMUtils.encode(authcode);
  msg.nopush = nopush;
  
  const buffer = net.msg_send_private_msg.encode(msg).finish();

  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_SEND_PRIVATE_MSG, buffer);
};

//发送群聊
export const msg_send_group_msg = (groupkey, content, type=1, clientkey = '', authcode = '', nopush = 0) => {
  const msg = new net.msg_send_group_msg();
  msg.msg_type = type;

  msg.groupkey = groupkey
  msg.content = IMUtils.encode(content);
  msg.clientkey = IMUtils.encode(clientkey);
  msg.authcode = IMUtils.encode(authcode);
  msg.nopush = nopush;
  const buffer = net.msg_send_group_msg.encode(msg).finish();

  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_SEND_GROUP_MSG, buffer);
};

export const msg_join_chatroom = (roomID) => {
  console.log("去加入直播间",roomID);
  
  const msg = new net.msg_join_chatroom();
  msg.roomkey = roomID;
  const buffer = net.msg_join_chatroom.encode(msg).finish();

  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_JOIN_CHATROOM, buffer);
};
//获取聊天室记录
export const get_room_history_msg = (roomID) => {
  let msg = new net.msg_get_chatroom_history_msg();
  msg.roomkey = roomID;
  let buffer = net.msg_get_chatroom_history_msg.encode(msg).finish();
  window.$Socket.send(
    net.CLIENT_MSG_ID.C2S_MSG_GET_CHATROOM_HISTORY_MSG,
    buffer
  );
};

//退出直播间
export const msg_quit_chatroom = (roomID) => {
  let msg = new net.msg_quit_chatroom();
  msg.roomkey = roomID;
  let buffer = net.msg_quit_chatroom.encode(msg).finish();
  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_QUIT_CHATROOM, buffer);
};

//发送文字
export const msg_send_chatroom_msg = (roomID, content) => {
  let msg = new net.msg_send_chatroom_msg();
  msg.roomkey = roomID;
  msg.msg_type = 1;
  msg.content = IMUtils.encode(content);
  let buffer = net.msg_send_chatroom_msg.encode(msg).finish();
  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_SEND_CHATROOM_MSG, buffer);
};

//查询用户资料
export const msg_get_user_info = (uid: number, fid: number = 0) => {
  let msg = new net.msg_get_user_info();
  msg.fid = fid;
  msg.phonenum = IMUtils.fromString(0);
  msg.uid = uid;
  const buffer = net.msg_get_user_info.encode(msg).finish();
  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_GET_USER_INFO, buffer);
};

//查询群资料
export const msg_get_group_info = (groupkey: number) => {
  let msg = new net.msg_get_group_info();
  msg.groupkey = groupkey;
  msg.is_stranger = 0;
  msg.is_end = 1;
  let buffer = net.msg_get_group_info.encode(msg).finish();
  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_GET_GROUP_INFO, buffer);
};

//上传头像
export const msg_set_headurl = (url: string) => {
  let msg = new net.msg_set_headurl();
  msg.headurl = IMUtils.encode(url);
  let buffer = net.msg_set_headurl.encode(msg).finish();
  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_SET_HEADURL, buffer);
};

export const msg_need_read_group_notify = (chatKey: number) => {
  let msg = new net.msg_need_read_group_notify();
  msg.groupkey = chatKey;
  let buffer = net.msg_need_read_group_notify.encode(msg).finish();
  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_NEED_READ_GROUP_NOTIFY, buffer);
}

export const msg_read_group_notify = (chatKey: number, notifyversion: number) => {
  let msg = new net.msg_read_group_notify();
  msg.groupkey = chatKey;
  msg.notifyversion = notifyversion;
  let buffer = net.msg_read_group_notify.encode(msg).finish();
  window.$Socket.send(net.CLIENT_MSG_ID.C2S_MSG_READ_GROUP_NOTIFY, buffer);
}



